import { PageFaqSection } from '../../ds';
import type { UcFaqSection } from '../../../lib/useCaseQueries';

type UcFaqSectionProps = {
  data: UcFaqSection;
  tone: 'light' | 'dark';
};

export function UcFaqSection({ data, tone }: UcFaqSectionProps) {
  const items = (data.items ?? []).map((item) => ({
    q: item.question,
    a: item.answer,
  }));

  return (
    <PageFaqSection
      id="faq"
      eyebrow={data.eyebrow ? `- ${data.eyebrow}` : '- Questions'}
      title={
        data.headingAccent ? (
          <>
            {data.heading}
            {data.heading ? ' ' : null}
            <em>{data.headingAccent}</em>
          </>
        ) : (
          (data.heading ?? 'Questions')
        )
      }
      items={items}
      initialOpenIndex={null}
      tone={tone}
    />
  );
}
